import { call, put, takeLatest } from 'redux-saga/effects';
import { fetchPasskeyGenerateCode } from '../api';
import {
  passkeyOtpGenerateFailure,
  passkeyOtpGenerateRequest,
  passkeyOtpGenerateSuccess,
} from '../reducer/passkeyOtpGenerateSlice';

const isSuccessStatus = (response: any): boolean =>
  response?.statusCode === '200' ||
  response?.statusCode === 200 ||
  response?.status === 200 ||
  response?.status === '200' ||
  response?.success === true;

export function* fetchPasskeyOtpGenerateSaga(
  action: ReturnType<typeof passkeyOtpGenerateRequest>
): Generator<any, void, unknown> {
  try {
    const response: any = yield call(fetchPasskeyGenerateCode, action.payload);
    if (isSuccessStatus(response)) {
      yield put(passkeyOtpGenerateSuccess());
    } else {
      yield put(passkeyOtpGenerateFailure(response));
    }
  } catch (error: any) {
    yield put(passkeyOtpGenerateFailure(error));
  }
}

export function* watchPasskeyOtpGenerateSaga() {
  yield takeLatest(passkeyOtpGenerateRequest.type, fetchPasskeyOtpGenerateSaga);
}
